import { FiArrowRight } from "react-icons/fi";
import { imgLinks, svgLinks } from "../../../public/assets/assetLinks.ts";
import { TextSection } from "@/components/custom";
import { Button } from "@/components/ui";
import { motion } from "motion/react";

export const HowItWorks = () => {
  return (
    <div
      id="solutions"
      className="lg:px-10 px-5 py-20 items-center justify-center flex-col flex"
    >
      <TextSection
        heading="How It Works"
        subtext="Qoonity makes code generation as easy as having a conversation. Just describe what you need, and watch the code appear — fast, accurate, and ready to use."
        className="mx-auto"
      />
      <div className="w-full lg:px-10 mt-20">
        <div className="flex lg:flex-row  w-full flex-col gap-10  items-center ">
          <motion.div
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "tween",
              ease: "easeInOut",
            }}
            className="bg-[#0B0C0E] border border-[#FFFFFF24]   flex-col items-center flex px-1 pt-2 rounded-3xl"
          >
            <div className="max-w-sm space-y-5 py-5 px-2">
              <img src={svgLinks.describeit} />
              <h6 className="text-white">Describe It</h6>
              <h1 className="text-sm text-[#FFFFFF99]">
                Type what you want in plain English — from simple functions to
                entire class structures.
              </h1>
            </div>
            <img
              src={imgLinks.howitworks1}
              className="rounded-b-3xl"
              loading="lazy"
            />
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "tween",
              ease: "easeInOut",
            }}
            className="bg-[#0B0C0E] border border-[#FFFFFF24] max-2/3 px-2 lg:px-10 inline-block  pt-2 rounded-3xl"
          >
            <div className="max-w-sm space-y-5 py-5 px-2">
              <img src={svgLinks.instantcode} />
              <h6 className="text-white">Get Instant Code</h6>
              <h1 className="text-sm text-[#FFFFFF99]">
                Type what you want in plain English — from simple functions to
                entire class structures.
              </h1>
            </div>
            <img src={imgLinks.instantcode} loading="lazy" />
          </motion.div>
        </div>
        <motion.div
          whileHover={{ scale: 1.05 }}
          transition={{
            type: "tween",
            ease: "easeInOut",
          }}
          className="bg-[#0B0C0E] border border-[#FFFFFF24] px-4 grid grid-cols-1 gap-5 lg:grid-cols-2 pt-5  mt-10  rounded-3xl"
        >
          <div className=" space-y-5 justify-center flex flex-col  px-2">
            <h6 className="text-white">Copy, Customize, Go</h6>
            <h1 className="text-sm max-w-sm  text-[#FFFFFF99]">
              Edit the generated code to match your specific requirements or
              style. Whether it's renaming variables, adjusting logic, or adding
              custom functions, you're in full control. Once you're happy with
              it, simply copy and paste it into your project. It’s fast,
              seamless, and built to fit right into your workflow — just like
              that.
            </h1>

            <div>
              <Button
                label="Try it Now!"
                surfixIcon={<FiArrowRight size={10} color="#FFFFFF99" />}
                size="sm"
              />
            </div>
          </div>
          <img src={imgLinks.qoonitysc} loading="lazy" />
        </motion.div>
      </div>
    </div>
  );
};
